import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ListButton } from "@refinedev/antd";
import { useGetIdentity } from "@refinedev/core";
import { Flex, Result, Spin, Tabs, Typography } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Robot2Line } from "@/components/icon/RobotIcon";
import { nivelDeOperadores } from "@/utilities/nivel-de-operadores";
import { agentApi } from "./api";
import { ConfiguracionTab } from "./ConfiguracionTab";
import { ConocimientoTab } from "./ConocimientoTab";

/**
 * Asistente IA del store (change conversaciones-agente-ia, tareas 5.1 y 5.5). El gate es el de la
 * API: `store_operators` Viewer para ver y Admin para guardar, igual que Operadores del Store.
 */
export const StoreAgentPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const storeCode = decodeURIComponent(id ?? "");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: identity } = useGetIdentity<any>();
  const [acceso, setAcceso] = useState<"cargando" | "ok" | "forbidden" | "error">("cargando");

  useEffect(() => {
    if (!storeCode) return;
    // Una lectura de prueba: si da 403 se muestra el motivo en vez de dos pestañas rotas.
    agentApi
      .config(storeCode)
      .then(() => setAcceso("ok"))
      .catch((e) => setAcceso(e?.response?.status === 403 ? "forbidden" : "error"));
  }, [storeCode]);

  const editable = nivelDeOperadores(identity, storeCode) === "admin";

  if (acceso === "cargando") {
    return (
      <Flex justify="center" align="center" style={{ minHeight: 400 }}>
        <Spin size="large" />
      </Flex>
    );
  }

  return (
    <Flex vertical style={{ height: "100%", minHeight: 0 }}>
      <Flex align="center" gap={8} style={{ marginBottom: 16, flexShrink: 0 }}>
        <Robot2Line style={{ fontSize: 22 }} />
        <Typography.Title level={3} style={{ marginBottom: 0 }}>
          {t("agent.title", "Asistente IA")}
        </Typography.Title>
      </Flex>

      <div style={{ flex: 1, overflowY: "auto" }}>
        {acceso === "ok" ? (
          <Tabs
            items={[
              {
                key: "config",
                label: "Configuración",
                children: <ConfiguracionTab storeCode={storeCode} editable={editable} />,
              },
              {
                key: "conocimiento",
                label: "Conocimiento",
                children: <ConocimientoTab storeCode={storeCode} editable={editable} />,
              },
            ]}
          />
        ) : (
          <Result
            status={acceso === "forbidden" ? "403" : "error"}
            title={
              acceso === "forbidden"
                ? "No tenés permisos para ver el asistente de este store"
                : "No se pudo cargar el asistente"
            }
            subTitle={
              acceso === "forbidden"
                ? "Pedile a un administrador del store el permiso de Operadores del Store."
                : "Volvé a intentar en un momento."
            }
          />
        )}
      </div>

      <div style={{ paddingTop: 32, paddingBottom: 16, flexShrink: 0 }}>
        <ListButton icon={<LeftOutlined />} onClick={() => navigate(-1)}>
          {t("buttons.back", "Volver")}
        </ListButton>
      </div>
    </Flex>
  );
};
